import { render, staticRenderFns } from "./CustomerTypeEdit.vue?vue&type=template&id=2443fc40"
import script from "./CustomerTypeEdit.vue?vue&type=script&lang=js"
export * from "./CustomerTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports